<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitlefw"><a id="page_v"></a><span class="ts2">Contents</span></h1>
<h2 class="chapEntryff"><a href="#/xhtml/07_intro#intro"><span class="ts2">Introduction: First All-Rounder</span></a></h2>
<h2 class="chapEntryfBb"><a href="#/xhtml/08_photo#photo"><span class="ts2">Photograph Sources</span></a></h2>
<h2 class="chapEntryt"><a href="#/xhtml/09_ch01#ch01">Chapter One</a></h2>
<h2 class="chapEntry1w"><a href="#/xhtml/09_ch01#ch01"><span class="ts2">Heir Apparent – T-54</span></a></h2>
<h2 class="chapEntryt"><span href="#/xhtml/10_ch02#ch02" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/10_ch02#ch02" title="Link target outside of Sample"><span class="ts2">Up Close and Personal</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/11_ch03#ch03" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/11_ch03#ch03" title="Link target outside of Sample"><span class="ts2">Fine Tuning – T-55</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/12_ch04#ch04" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/12_ch04#ch04" title="Link target outside of Sample"><span class="ts2">T-54/55 Specialized Variants</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/13_ch05#ch05" title="Link target outside of Sample">Chapter Five</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/13_ch05#ch05" title="Link target outside of Sample"><span class="ts2">Warsaw Pact Copies</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/14_ch06#ch06" title="Link target outside of Sample">Chapter Six</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/14_ch06#ch06" title="Link target outside of Sample"><span class="ts2">Chinese Cousins</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/15_ch07#ch07" title="Link target outside of Sample">Chapter Seven</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/15_ch07#ch07" title="Link target outside of Sample"><span class="ts2">Middle-Eastern Upgrades</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/16_ch08#ch08" title="Link target outside of Sample">Chapter Eight</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/16_ch08#ch08" title="Link target outside of Sample"><span class="ts2">Darling of the Left</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/17_ch09#ch09" title="Link target outside of Sample">Chapter Nine</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/17_ch09#ch09" title="Link target outside of Sample"><span class="ts2">Desert Failure</span></span></h2>
<h2 class="chapEntryt"><a id="page_vi"></a><span href="#/xhtml/18_ch10#ch10" title="Link target outside of Sample">Chapter Ten</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/18_ch10#ch10" title="Link target outside of Sample"><span class="ts2">European Swansong</span></span></h2>
<h2 class="chapEntryt"><span href="#/xhtml/19_ch11#ch11" title="Link target outside of Sample">Chapter Eleven</span></h2>
<h2 class="chapEntry1w"><span href="#/xhtml/19_ch11#ch11" title="Link target outside of Sample"><span class="ts2">How to Win Friends</span></span></h2>
<h2 class="chapEntryfTv"><span href="#/xhtml/20_posts#post" title="Link target outside of Sample"><span class="ts2">Postscript: ‘Soviet made shit’</span></span></h2>
<h2 class="chapEntryff"><span href="#/xhtml/21_further#fur" title="Link target outside of Sample"><span class="ts2">Further Reading</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7e3a3391